var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group col-12"},[_c('label',[_vm._v("Form")]),_c('form-selector',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }